import { cn } from "@theprelude/core";

export const VSTIndicatorIcon: React.FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <div
      className={cn(
        "bg-tertiary-background flex w-max items-center gap-1 px-1 py-0.5 text-xs text-white",
        className,
      )}
    >
      VST
    </div>
  );
};
